import {
  useGetTriviaDailyQuery,
  useStartTriviaDailyGameMutation,
  useGetTriviaDailyLeaderboardQuery,
} from "../store/api/mlbApi";

export const useTriviaDaily = (sport = "mlb") => {
  const dailyQuery = useGetTriviaDailyQuery(sport);
  const leaderboardQuery = useGetTriviaDailyLeaderboardQuery(sport);
  const [startDaily, startState] = useStartTriviaDailyGameMutation();

  return {
    daily: dailyQuery.data || null,
    leaderboard: leaderboardQuery.data || null,
    isLoading: dailyQuery.isLoading,
    isStarting: startState.isLoading,
    alreadyPlayed: Boolean(dailyQuery.data?.played),
    startDaily: () => startDaily({ sport }).unwrap(),
    refetchDaily: dailyQuery.refetch,
    refetchLeaderboard: leaderboardQuery.refetch,
  };
};
